/* eslint-disable no-console */
import {
  ICommonResponse,
  IFinalResponse,
  IGenericResponseData,
  ErrorsDetailsTypes,
} from '_core/types';

import { handleCodeErrorsResponse } from './codeErrorsResponse';
import { isRangeNumber } from './object';

const statusServiceSuccess = [[200, 201, 203, 204]];

export const prepareGenericData = (
  contexts: (ICommonResponse | IFinalResponse | null)[],
  keys: string[],
  definitions: unknown[] | null | undefined,
): IGenericResponseData => {
  const errors: ErrorsDetailsTypes[] = [];

  let finalResponse: IGenericResponseData = {
    data: null,
    errors: [],
  };

  let eachResponseAvaiable = {};
  contexts.map((context, i) => {
    if (
      context &&
      context.statusCode &&
      typeof context.statusCode === 'number'
    ) {
      const isServiceSuccess = isRangeNumber(
        context.statusCode,
        statusServiceSuccess,
      );
      if (!isServiceSuccess) {
        errors.push({
          entity: context?.errorMetadata || keys[i],
          errorCode: context?.errorCode,
          errorMessage: context?.errorMessage,
          errorMetadata: keys[i],
        });
      } else {
        eachResponseAvaiable = context?.response;
      }
    } else {
      eachResponseAvaiable = context?.response;
    }
  });

  const infos = handleCodeErrorsResponse(errors, definitions);
  let finalData = null;
  if (typeof eachResponseAvaiable === 'string') {
    finalData = eachResponseAvaiable;
  } else if (Array.isArray(eachResponseAvaiable)) {
    finalData = eachResponseAvaiable;
  } else if (typeof eachResponseAvaiable === 'object') {
    finalData = eachResponseAvaiable;
  }
  finalResponse = {
    data: finalData,
    errors: errors,
    infos,
  };
  return finalResponse;
};
//   statusCodesToRetry: [[100, 199], [429, 429], [500, 599]],
